import Icon from '../components/Icon.vue'

Icon.register({
  'map-marker-alt': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M172.3 501.7c-145.3-210.6-172.3-232.3-172.3-309.7 0-106 86-192 192-192s192 86 192 192c0 77.4-27 99-172.3 309.7-9.5 13.8-29.9 13.8-39.5 0zM192 272c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/map-marker-alt.js
// module id = 1544
// module chunks = 0